import { render, staticRenderFns } from "./UserTrainingPendingModal.vue?vue&type=template&id=46a2235d"
import script from "./UserTrainingPendingModal.vue?vue&type=script&lang=ts"
export * from "./UserTrainingPendingModal.vue?vue&type=script&lang=ts"
import style0 from "./UserTrainingPendingModal.vue?vue&type=style&index=0&id=46a2235d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports